module.exports = __webpack_public_path__ + "img/SKMJ_light2.4ef9ce33.jpg";